'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getProviderLogo } from '@tables/user-provider-logos';

export default class ProviderLogo extends Component {
    static propTypes = {
        provider: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: '',
    };

    render() {
        const { provider, label, className } = this.props;
        const src = getProviderLogo(provider);

        if (!src) {
            return null;
        }

        return <img className={`provider-logo ${className}`.trim()} src={src} alt={`${label} logo`} />;
    }
}
